// The "Sign in with Microsoft" MSAL popup returns to the app origin (its redirectUri) with the
// OAuth response in the URL (`#code=…` / `?error=…`). The opener reads it by polling the popup
// URL, so if the root route navigates away first, the response is stripped and login silently
// fails. Detect that return so the root route can hold instead of redirecting.
export const isFederatedAuthPopupReturn = (searchAndHash: string): boolean =>
  /[?#&](code|id_token|error)=/.test(searchAndHash);
